<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <div
        class="login100-form-title"
        style="background-image: url(/assets/images/huacachina.jpeg)"
      >
        <span class="login100-form-title-1"> Denuncias Ambientales </span>
      </div>

      <form class="login100-form validate-form">
        <!--<h3 style="margin-bottom: 25px; font-size: 25px">
          Aspectos Generales
        </h3>-->
        <div
          class="wrap-input100 validate-input m-b-26"
          data-validate="Username is required"
        >
          <span class="label-input100">Fecha</span>
          <input
            class="input100"
            type="text"
            name="date"
            [(ngModel)]="date"
            value="Aqui va la fecha"
            disabled
          />
          <span class="focus-input100"></span>
        </div>

        <h3
          style="
            margin-bottom: 25px;
            font-size: 25px;
            margin-top: 30px !important;
          "
        >
          Datos del Denunciante
        </h3>

        <div
          class="wrap-input100 validate-input m-b-18"
          style="border-bottom: none !important"
        >
          <span class="label-input100" style="top: 8px">Tipo de Persona</span>
          <select
            class="form-control"
            id="typePerson"
            name="typeperson"
            [(ngModel)]="denuncia.typePerson"
            (change)="personD = !personD"
          >
            <option selected>Persona Natural</option>
            <option>Persona Juridica</option>
          </select>
          <span class="focus-input100"></span>
        </div>

        <!--Persona Natural-->

        <div
          style="width: 100% !important"
          *ngIf="personD"
          class="animate__animated animate__fadeInUp"
        >
          <div
            class="wrap-input100 validate-input m-b-26"
            data-validate="Username is required"
          >
            <span class="label-input100">Nombre</span>
            <input
              class="input100"
              type="text"
              name="username"
              [(ngModel)]="naturalPerson.name"
              placeholder="Ingresar Nombre"
              required
              minlength="3"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPerson.name)"></span>
            <span class="focus-input100"></span>
            
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Apellido Paterno</span>
            <input
              class="input100"
              type="text"
              name="lastname"
              [(ngModel)]="naturalPerson.lastnamep"
              placeholder="Ingresar Apellido Paterno"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPerson.lastnamep)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Apellido Materno</span>
            <input
              class="input100"
              type="text"
              name="latname"
              [(ngModel)]="naturalPerson.lastnamem"
              placeholder="Ingresar Apellido Paterno"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPerson.lastnamem)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">DNI</span>
            <input
              class="input100"
              type="number"
              name="dni"
              [(ngModel)]="naturalPerson.dni"
              placeholder="Ingresar DNI"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPerson.dni)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Persona Natural-->

        <!--Persona Juridica-->

        <div
          style="width: 100% !important"
          *ngIf="!personD"
          class="animate__animated animate__fadeInUp"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Razon Social</span>
            <input
              class="input100"
              type="text"
              name="razon"
              [(ngModel)]="juridicPerson.razonSocial"
              placeholder="Ingresar Razon Social"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPerson.razonSocial)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Representante Legal</span>
            <input
              class="input100"
              type="text"
              name="username"
              [(ngModel)]="juridicPerson.representL"
              placeholder="Ingresar Representante Legal"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPerson.representL)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">RUC</span>
            <input
              class="input100"
              type="number"
              name="ruc"
              [(ngModel)]="juridicPerson.ruc"
              placeholder="Ingresar RUC"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPerson.ruc)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Persona Juridica-->

        <!--Direccion-->

        <div
          style="width: 100% !important"
          class="animate__animated animate__fadeInUp"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Departamento</span>
            <select
              class="form-control"
              id="departament"
              name="departament"
              [(ngModel)]="idDepartament"
              (change)="selectDepartament()"
            >
              <option *ngFor="let item of departaments" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Provincia</span>
            <select
              class="form-control"
              id="province"
              name="departament"
              [(ngModel)]="idProvince"
              (change)="selectProvince()"
            >
              <option *ngFor="let item of provincesC" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Distrito</span>
            <select
              class="form-control"
              id="district"
              name="distric"
              [(ngModel)]="address.district"
            >
              <option *ngFor="let item of districtC">{{ item.name }}</option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Direccion</span>
            <input
              class="input100"
              type="text"
              name="addresse"
              [(ngModel)]="address.addressT"
              placeholder="Ingresar Direccion"
            />
            <span class="focus-input101" *ngIf="!validator(address.addressT)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Codigo Postal</span>
            <input
              class="input100"
              type="number"
              name="postale"
              [(ngModel)]="additional.postal"
              placeholder="Ingresar Codigo Postal"
            />
            <span class="focus-input101" *ngIf="!validator(additional.postal)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Telefono</span>
            <input
              class="input100"
              type="number"
              name="cele"
              [(ngModel)]="additional.cel"
              placeholder="Ingresar Telefono"
            />
            <span class="focus-input101" *ngIf="!validator(additional.cel)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Correo Electronico</span>
            <input
              class="input100"
              type="email"
              name="emaile"
              [(ngModel)]="additional.email"
              placeholder="Ingresar Correo Electronico"
            />
            <span class="focus-input101" *ngIf="!validator(additional.email)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Direccion-->

        <h4
          style="
            margin-bottom: 25px;
            font-size: 25px;
            margin-top: 30px !important;
          "
        >
          Denuncia Previa
        </h4>

        <div
          class="wrap-input100 validate-input m-b-18"
          style="border-bottom: none !important"
        >
          <span class="label-input100" style="top: 5px"
            >¿Has realizado alguna?</span
          >
          <select
            class="form-control"
            id="denunc"
            (change)="denunciaP = !denunciaP"
            name="prev"
            [(ngModel)]="denuncia.deunciaPrev"
          >
            <option>Si</option>
            <option selected>No</option>
          </select>
          <span class="focus-input100"></span>
        </div>

        <div
          class="ancho animate__animated animate__fadeInUp"
          *ngIf="denunciaP"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 5px"
              >¿Ante que entidades?</span
            >
            <select
              class="form-control"
              id="entida"
              name="entidad"
              [(ngModel)]="denuncia.entidad"
            >
              <option *ngFor="let item of entidades">{{ item }}</option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 5px"
              >¿Obtuvo Respuesta?</span
            >
            <select
              class="form-control"
              id="respu"
              name="resp"
              [(ngModel)]="denuncia.respuestS"
              (change)="respuestP = !respuestP"
            >
              <option selected>Si</option>
              <option>No</option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18 animate__animated animate__fadeInUp"
            data-validate="Password is required"
            *ngIf="respuestP"
          >
            <span class="label-input100">¿Cual fue la respuesta?</span>
            <input
              class="input100"
              type="text"
              name="respT"
              [(ngModel)]="denuncia.respuestText"
              placeholder="Ingresar Respuesta"
            />
            <span class="focus-input101" *ngIf="!validator(denuncia.respuestText)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Medio de Comunicacion</span>
            <input
              class="input100"
              type="text"
              name="medio"
              [(ngModel)]="denuncia.medio"
              placeholder="Ingresar Medio"
            />
            <span class="focus-input101" *ngIf="!validator(denuncia.medio)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Fuente</span>
            <input
              class="input100"
              type="text"
              name="fuente"
              [(ngModel)]="denuncia.fuente"
              placeholder="Ingresar Fuente"
            />
            <span class="focus-input101" *ngIf="!validator(denuncia.fuente)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 0px"
              >¿Mantener su identidad en reserva?</span
            >
            <select
              class="form-control"
              id="identi"
              name="ident"
              [(ngModel)]="denuncia.identidadR"
            >
              <option>Si</option>
              <option>No</option>
            </select>
            <span class="focus-input100"></span>
          </div>
        </div>

        <h3
          style="
            margin-bottom: 25px;
            font-size: 25px;
            margin-top: 30px !important;
          "
        >
          Datos del Denunciado
        </h3>

        <div
          class="wrap-input100 validate-input m-b-18"
          style="border-bottom: none !important"
        >
          <span class="label-input100" style="top: 8px">Tipo de Persona</span>
          <select
            class="form-control"
            id="type"
            name="person"
            [(ngModel)]="denuncia.typePersonD"
            (change)="personDo = !personDo"
          >
            <option selected>Persona Natural</option>
            <option>Persona Juridica</option>
          </select>
          <span class="focus-input100"></span>
        </div>

        <!--Persona Natural-->

        <div class="ancho animate__animated animate__fadeInUp" *ngIf="personDo">
          <div
            class="wrap-input100 validate-input m-b-26"
            data-validate="Username is required"
          >
            <span class="label-input100">Nombre</span>
            <input
              class="input100"
              type="text"
              name="usernamed"
              [(ngModel)]="naturalPersonD.name"
              placeholder="Ingresar Nombre"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPersonD.name)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Apellido Paterno</span>
            <input
              class="input100"
              type="text"
              name="lastnamed"
              [(ngModel)]="naturalPersonD.lastnamep"
              placeholder="Ingresar Apellido Paterno"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPersonD.lastnamep)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Apellido Materno</span>
            <input
              class="input100"
              type="text"
              name="latnamed"
              [(ngModel)]="naturalPersonD.lastnamem"
              placeholder="Ingresar Apellido Paterno"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPersonD.lastnamem)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">DNI</span>
            <input
              class="input100"
              type="number"
              name="dnie"
              [(ngModel)]="naturalPersonD.dni"
              placeholder="Ingresar DNI"
            />
            <span class="focus-input101" *ngIf="!validator(naturalPersonD.dni)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Persona Natural-->

        <!--Persona Juridica-->

        <div
          class="ancho animate__animated animate__fadeInUp"
          *ngIf="!personDo"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Razon Social</span>
            <input
              class="input100"
              type="text"
              name="razone"
              [(ngModel)]="juridicPersonD.razonSocial"
              placeholder="Ingresar Razon Social"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPersonD.razonSocial)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Representante Legal</span>
            <input
              class="input100"
              type="text"
              name="representante"
              [(ngModel)]="juridicPersonD.representL"
              placeholder="Ingresar Representante Legal"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPersonD.representL)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">RUC</span>
            <input
              class="input100"
              type="number"
              name="rucd"
              [(ngModel)]="juridicPersonD.ruc"
              placeholder="Ingresar RUC"
            />
            <span class="focus-input101" *ngIf="!validator(juridicPersonD.ruc)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Persona Juridica-->

        <!--Direccion-->

        <div
          style="width: 100% !important"
          class="animate__animated animate__fadeInUp"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Departamento</span>
            <select
              class="form-control"
              id="depart"
              name="departament"
              [(ngModel)]="idDepartamentD"
              (change)="selectDepartamentD()"
            >
              <option *ngFor="let item of departaments" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Provincia</span>
            <select
              class="form-control"
              id="provinc"
              name="departament"
              [(ngModel)]="idProvinceD"
              (change)="selectProvinceD()"
            >
              <option *ngFor="let item of provincesD" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Distrito</span>
            <select
              class="form-control"
              id="distric"
              name="distr"
              [(ngModel)]="addressD.district"
            >
              <option *ngFor="let item of districtD">{{ item.name }}</option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Direccion</span>
            <input
              class="input100"
              type="text"
              name="addressd"
              [(ngModel)]="addressD.addressT"
              placeholder="Ingresar Direccion"
            />
            <span class="focus-input101" *ngIf="!validator(addressD.addressT)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Codigo Postal</span>
            <input
              class="input100"
              type="number"
              name="postald"
              [(ngModel)]="additionalD.postal"
              placeholder="Ingresar Codigo Postal"
            />
            <span class="focus-input101" *ngIf="!validator(additionalD.postal)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Telefono</span>
            <input
              class="input100"
              type="number"
              name="celd"
              [(ngModel)]="additionalD.cel"
              placeholder="Ingresar Telefono"
            />
            <span class="focus-input101" *ngIf="!validator(additionalD.cel)"></span>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Correo Electronico</span>
            <input
              class="input100"
              type="email"
              name="emaild"
              [(ngModel)]="additionalD.email"
              placeholder="Ingresar Correo Electronico"
            />
            <span class="focus-input101" *ngIf="!validator(additionalD.email)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Direccion-->

        <h3
          style="
            margin-bottom: 25px;
            font-size: 25px;
            margin-top: 30px !important;
          "
        >
          Descripcion de los Hechos
        </h3>

        <!--Direccion-->

        <!--Direccion-->

        <div
          style="width: 100% !important"
          class="animate__animated animate__fadeInUp"
        >
          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Departamento</span>
            <select
              class="form-control"
              id="depa"
              name="departament"
              [(ngModel)]="idDepartamentR"
              (change)="selectDepartamentR()"
            >
              <option *ngFor="let item of departaments" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Provincia</span>
            <select
              class="form-control"
              id="prov"
              name="departament"
              [(ngModel)]="idProvinceR"
              (change)="selectProvinceR()"
            >
              <option *ngFor="let item of provincesR" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            style="border-bottom: none !important"
          >
            <span class="label-input100" style="top: 8px">Distrito</span>
            <select
              class="form-control"
              id="distri"
              name="districto"
              [(ngModel)]="addressR.district"
            >
              <option *ngFor="let item of districtR">{{ item.name }}</option>
            </select>
            <span class="focus-input100"></span>
          </div>

          <div
            class="wrap-input100 validate-input m-b-18"
            data-validate="Password is required"
          >
            <span class="label-input100">Direccion</span>
            <input
              class="input100"
              type="text"
              name="addressr"
              [(ngModel)]="addressR.addressT"
              placeholder="Ingresar Direccion"
            />
            <span class="focus-input101" *ngIf="!validator(addressR.addressT)"></span>
            <span class="focus-input100"></span>
          </div>
        </div>

        <!--Fin Direccion-->

        <div
          class="wrap-input100 validate-input m-b-18"
          data-validate="Password is required"
        >
          <span class="label-input100">Georreferencia del Lugar</span>
          <input
            class="input100"
            type="text"
            name="geor"
            [(ngModel)]="denuncia.georeferenceR"
            placeholder="Ingresar Georreferencia"
          />
          <span class="focus-input101" *ngIf="!validator(denuncia.georeferenceR)"></span>
          <span class="focus-input100"></span>
        </div>

        <!--Fin Direccion-->

        <div
          class="wrap-input100 validate-input m-b-18"
          data-validate="Password is required"
        >
          <span class="label-input100">Descripcion de los Hechos</span>
          <textarea
            class="input100"
            style="margin-top: 20px !important"
            name="desc"
            [(ngModel)]="denuncia.descriptionH"
            id="hecho"
            cols="30"
            rows="10"
          ></textarea>
          <span class="focus-input101" *ngIf="!validator(denuncia.descriptionH)"></span>
          <span class="focus-input100"></span>
        </div>

        <!--<div class="flex-sb-m w-full p-b-30">
          <div class="contact100-form-checkbox">
            <input
              class="input-checkbox100"
              id="ckb1"
              type="checkbox"
              name="remember-me"
            />
            <label class="label-checkbox100" for="ckb1">
              Remember me
            </label>
          </div>

          <div>
            <a href="#" class="txt1"> Forgot Password? </a>
          </div>
        </div>-->

        <re-captcha
          style="margin-bottom: 20px"
          (resolved)="resolved($event)"
          siteKey="{{ siteKeyCaptcha }}"
        ></re-captcha>

        <div class="container-login100-form-btn">
          <button
            class="login100-form-btn"
            (click)="openSwal()"
          >
            Aceptar y Enviar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
